export const Config = {
  name: "2 Pay Me",
  favIcon: "",
  mainColor: "#0255B2",
  logo: require("../assets/img/logo.svg"),
  hideNavbarOnPages: ["/checkout"],
  layout: {
    toastPosition: "top-right",
  },
  langs: [
    {
      id: 1,
      title: "English",
      code: "en",
    },
    {
      id: 2,
      title: "العربية",
      code: "ar",
    },
  ],
  headerSwitcher: [
    {
      id: 1,
      title: "Brigge",
      link: "/",
    },
  ],
};
